import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../img/logo.png';
import '../../scss/v2/v2-base.scss';
import '../../scss/v2/v2-pages.scss';

const Missing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Сторінку не знайдено | New Brain';
  }, []);

  return (
    <main className="nf-page">
      <img className="nf-page__logo" src={Logo} alt="New Brain" width="56" height="64" />
      <span className="nf-page__code">404</span>
      <h1 className="nf-page__title">Сторінку не знайдено</h1>
      <p className="nf-page__text">Можливо, посилання застаріло або в адресі помилка. Поверніться в кабінет — усе на місці.</p>
      <div className="nf-page__actions">
        <button type="button" className="v2-btn v2-btn--violet" onClick={() => navigate('/')}>На головну кабінету</button>
        <button type="button" className="v2-btn v2-btn--outline" onClick={() => navigate(-1)}>Назад</button>
      </div>
    </main>
  );
};

export default Missing;
